// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PQ1g","buttons":"styles_buttons__t6B0C"};